import io from "socket.io-client";

const socketServerURL = "https://api.pulse-experience.co";
// const socketServerURL = "http://localhost";
// if (ENV_TYPE === 'production') {
//   socketServerURL = 'https://api.pulse-experience.co';
// } else if (ENV_TYPE === 'local') {
//   socketServerURL = 'http://localhost';
// }
const socket = io(socketServerURL);

export default socket;
